import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGUAGES, TRANSLATIONS } from "./translations";

const I18nContext = createContext(null);

const STORAGE_KEY = "goalgrid_lang";
const DEFAULT_LANG = "nl";

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && TRANSLATIONS[stored]) return stored;
    } catch (e) { /* ignore */ }
    return DEFAULT_LANG;
  });

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.rtl ? "rtl" : "ltr";
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) { /* ignore */ }
  }, [lang]);

  const t = useCallback((key, vars = {}) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS[DEFAULT_LANG];
    let s = dict[key] ?? TRANSLATIONS[DEFAULT_LANG][key] ?? key;
    for (const k of Object.keys(vars)) {
      s = s.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
    }
    return s;
  }, [lang]);

  const value = { lang, setLang, t, languages: LANGUAGES };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
